import Vue from "vue";
import analytics from "../../utils/analytics";
import analyticsPlugin from "../../utils/eventAnalytics/plugin";

const state = {
	models: sessionStorage.getItem("boosted-multibet-models")
		? JSON.parse(sessionStorage.getItem("boosted-multibet-models"))
		: {},
};

const getDefaultModel = () => {
	return Object.assign(
		{},
		{
			betslip: [],
			stake: null,
		}
	);
};

const persistModel = (key, item) => {
	let models = sessionStorage.getItem("boosted-multibet-models")
		? JSON.parse(sessionStorage.getItem("boosted-multibet-models"))
		: {};
	models[key] = item;
	sessionStorage.setItem("boosted-multibet-models", JSON.stringify(models));
};

const getters = {
	model: (state) => (id) => {
		return state.models[id] ? state.models[id] : getDefaultModel();
	},
};

const mutations = {
	addToBetslip(state, bet) {
		let model = state.models[bet.id] ? state.models[bet.id] : getDefaultModel();
		model.betslip.push(Object.assign({}, bet));
		Vue.set(state.models, bet.id, model);
		persistModel(bet.id, model);
		analyticsPlugin.betSlip.add({
			appName: "MOBILE_WEB",
			betType: "sababisha",
			display: bet.display || null,
			matchId: bet.matchId || null,
			profileId: window.localStorage.getItem("user")
				? JSON.parse(window.localStorage.getItem("user")).id
				: "",
			betPick: bet.bet_pick || null,
			homeTeam: bet.home_team || null,
			awayTeam: bet.away_team || null,
			oddValue: bet.odd_value || null,
			market: bet.market || null,
			startTime: bet.startTime || null,
		});
	},
	removeFromBetslip(state, bet) {
		let model = state.models[bet.id] ? state.models[bet.id] : getDefaultModel();
		model.betslip = model.betslip.filter(
			(b) => b.match.parent_match_id != bet.match.parent_match_id
		);
		Vue.set(state.models, bet.id, model);
		persistModel(bet.id, model);
	},
	updateStake(state, payload) {
		let model = state.models.hasOwnProperty(payload.id)
			? Object.assign({}, state.models[payload.id])
			: getDefaultModel();
		model.stake = Object.assign({}, payload.stake);
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	clear(state, id) {
		let model = state.models[id] ? state.models[id] : getDefaultModel();
		model.betslip = [];
		Vue.set(state.models, id, model);
		persistModel(id, model);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
